import { concat, map } from 'lodash';

import urls from '../constants/urls';

import { REQUEST_INVITE_SUCCESS } from './inviteRequests';

export const HOSPITALS_LOAD_FAILED = 'hospitals/HOSPITALS_LOAD_FAILED';
export const HOSPITALS_LOAD_SUCCESS = 'hospitals/HOSPITALS_LOAD_SUCCESS';
export const LOADING_HOSPITALS = 'hospitals/LOADING_HOSPITALS';

export const CREATE_HOSPITAL_SUCCESS = 'hospitals/CREATE_HOSPITAL_SUCCESS';
export const CREATE_HOSPITAL_FAILED = 'hospitals/CREATE_HOSPITAL_FAILED';
export const CREATING_HOSPITAL = 'hospitals/CREATING_HOSPITAL';

const initialState = {
  initialLoad: true,

  hospitals: [],

  // Permissions
  readableHospitalIds: [],
  editableHospitalIds: [],
  adminableHospitalIds: [], // All hospitals that the user can admin, read below for more info.

  // Records that exist
  adminedHospitalIds: [], // All hospitals that the user is specifically an admin for, read below for more info.
  favouritedHospitalIds: [],
  inviteRequestedHospitalIds: [],

  failedLoading: false,
  failedCreating: false,

  isLoading: false,
  isCreating: false,

  page: 1,
  preSearchTotal: 0,
  total: 0,
};

// adminableHospitalIds is all the hospitals the user can admin. For a hospital admin this will equal adminedHospitalIds
// as these users can only admin the hospitals they've been set for. For induction admins however this will differ
// since they can admin all hospitals.
// This difference is important because there's a difference between being made an admin for a hospital and just being
// a super user. So use adminableHospitalIds for checking permissions and adminedHospitalIds for manipulating
// these permissions.

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_HOSPITALS:
      return {
        ...state,
        failedLoading: false,
        isLoading: true,
      };

    case HOSPITALS_LOAD_SUCCESS:
      let payloadData = action.payload.data;

      return {
        ...state,
        adminableHospitalIds: payloadData.data.adminable_hospital_ids,
        adminedHospitalIds: payloadData.data.admined_hospital_ids,
        editableHospitalIds: payloadData.data.editable_hospital_ids,
        favouritedHospitalIds: payloadData.data.favourited_hospital_ids,
        hospitals: payloadData.data.hospitals,
        inviteRequestedHospitalIds:
          payloadData.data.invite_requested_hospital_ids,
        readableHospitalIds: payloadData.data.readable_hospital_ids,
        page: payloadData.meta.page,
        pages: payloadData.meta.pages,
        preSearchTotal: payloadData.meta.pre_search_total,
        total: payloadData.meta.total,
        searchTerm: action.meta.previousAction.searchTerm,
        initialLoad: false,
        isLoading: false,
      };

    case HOSPITALS_LOAD_FAILED:
      return {
        ...state,
        failedLoading: true,
        isLoading: false,
      };

    // Handle a succesful invite request creation from the inviteRequests reducer
    // If the request was for a hospital then we should mark it as invite_requested
    case REQUEST_INVITE_SUCCESS:
      let requestedHospitalId = action.meta.previousAction.hospitalId;

      const updatedHospitals = map(state.hospitals, hospital => {
        if (requestedHospitalId === hospital.id) {
          hospital.invite_requested = true;
        }
        return hospital;
      });

      return {
        ...state,
        hospitals: updatedHospitals,
        inviteRequestedHospitalIds: concat(state.inviteRequestedHospitalIds, [
          requestedHospitalId,
        ]),
      };

    case CREATING_HOSPITAL:
      return {
        ...state,
        failedCreating: false,
        isCreating: true,
      };

    case CREATE_HOSPITAL_SUCCESS:
      return {
        ...state,
        isCreating: false,
      };

    case CREATE_HOSPITAL_FAILED:
      return {
        ...state,
        failedCreating: true,
        isCreating: false,
      };

    default:
      return state;
  }
};

export const loadHospitals = (page = 1, searchTerm = '') => dispatch => {
  return dispatch({
    types: [LOADING_HOSPITALS, HOSPITALS_LOAD_SUCCESS, HOSPITALS_LOAD_FAILED],
    payload: {
      request: {
        url: urls.hospitals.index,
        params: { page, search_string: searchTerm },
      },
    },
    searchTerm: searchTerm,
  });
};

export const createHospital = params => dispatch => {
  const hospitalParams = {
    name: params.name,
    nickname: params.nickname,
    prefix: params.prefix,
    drop_prefix: params.drop_prefix,
    closed_network_enabled: params.closed_network_enabled,
    organisation_id: params.organisation_id,
    directory_enabled: params.directory_enabled,
    messaging_enabled: params.closed_network_enabled && params.messaging_enabled,
  };

  return dispatch({
    types: [CREATING_HOSPITAL, CREATE_HOSPITAL_SUCCESS, CREATE_HOSPITAL_FAILED],
    payload: {
      request: {
        method: 'post',
        url: urls.hospitals.create,
        data: { hospital: hospitalParams },
      },
    },
  });
};
